export var EntityAttrKind;
(function (EntityAttrKind) {
    EntityAttrKind[EntityAttrKind["Data"] = 0] = "Data";
    EntityAttrKind[EntityAttrKind["Virtual"] = 1] = "Virtual";
    EntityAttrKind[EntityAttrKind["Lookup"] = 2] = "Lookup";
})(EntityAttrKind || (EntityAttrKind = {}));
//# sourceMappingURL=entity_attr_kind.js.map